export const featureFlags = {
  wishesAndGoalsStandalone: 'feature.vpd.wishes-and-goals-standalone',
  avdSelectionSupport: 'feature.catalog.avd-selection-support',
} as const;
